export const GET_CART_DETAILS = "APP/CART_PAGE/GET_CART_DETAILS";
export const GET_CART_DETAILS_SUCCESS = "APP/CART_PAGE/GET_CART_DETAILS_SUCCESS";
export const GET_CART_DETAILS_FAILURE = "APP/CART_PAGE/GET_CART_DETAILS_FAILURE";

export const RESET_CART_TO_INITIAL_STATE = "APP/CHECKOUT_PAGE/RESET_CART_TO_INITIAL_STATE";


